export default {
    dirPidiendoActiva(state){
        return state.dirPidiendo != null
    },
    dirPidiendoNueva(state){
        return (state.dirPidiendo) ? state.dirPidiendo.id_direccion == null : true;
    },
    getDirPidiendo(){
    	return localStorage.getItem('dirPidiendo') != null ? JSON.parse( localStorage.getItem('dirPidiendo') ) : {};
    },
    direccionCacheFormateada(state){
    	let formated = state.direccionCache;
    	let addr = state.direccionCache;

    	if(Object.keys( addr ).length > 0){

    		let numer 	= addr.numer != undefined ? ", "+addr.numer : '';
            let cp 		= addr.cp != undefined ? ", "+addr.cp : '';
            let provincia = addr.provincia != undefined ? ", "+addr.provincia : '';

	        formated["coordenadas"] 	= addr.coordenadas;
			formated["calle_numero"] 	= addr.calle + numer;
			formated["datos_aux"] 		= addr.adicional;
			formated["mun_cp_prov"] 	= addr.municipio + cp + provincia;
			formated["cacheada"] 		= true;
    	}

    	return formated;
    }

}